export const initialState = {
  init: false,
  isFormOpen: false,
  isApplyButtonDisabled: false,
  process: null,
};
